export enum BenefitType {
  Common = 0,
  Car = 1,
  CarNetDeduction = 2,
  ResidenceSmallNetDeduction = 3,
  NetDeduction = 4,
  SalarySacrifice = 5,
  ResidenceSmallGrossIncrease = 6,
  ResidenceNonSmallNetDeduction = 7,
  ResidenceNonSmallGrossIncrease = 8,
  RentalCompensation = 9,
  GrossDeduction = 10,
  NetDeductionNoVat = 11,
  NetDeductionInsurance = 12,
}

export enum BenefitFrequency {
  Monthly,
  Once,
}

export enum CarBenefitSearchMethod {
  ModelNumber = 0,
  SearchPersonalCar = 1,
  SearchLightTruck = 2,
}
